import { Grid } from '@mui/material';
import { dateFormatShortTime } from '@nx-smartmonkey/shared/helpers';
import { RoutalPalette } from '@nx-smartmonkey/ui';

import { DriverProgress, DriverProgressItem } from '../../../../../components/DriversProgress';
import { Route } from '../../../../../domain/route/Route';
import { Stop } from '../../../../../domain/stop/Stop';
import { Text } from '../../../../../react-components/Text';
import { ItemsSeparator } from '../../../components/ItemsSeparator';
import { RouteLabel } from './RouteLabel';

type InTransitProps = {
  selectedRoute: Route;
  isOnline?: boolean;
};

export const InTransit = ({ selectedRoute, isOnline }: InTransitProps) => {
  return (
    <Grid
      container
      direction="column"
      gap="6px"
      style={{
        padding: `0 20px`,
        paddingBottom: `12px`,
      }}
    >
      <RouteLabel selectedRoute={selectedRoute} isOnline={isOnline} />

      <Grid container direction="row" gap="8px" alignItems="center">
        <Text
          variant="body"
          style={{ color: RoutalPalette.secondary00 }}
          intlId="drivers.route_header.pending_stops"
          intlValues={{ num: selectedRoute.getNumberPendingStops() }}
        />
        {selectedRoute.estimated_end_time !== undefined && (
          <>
            <ItemsSeparator />
            <Text
              variant="body"
              style={{ color: RoutalPalette.secondary00 }}
              intlId="drivers.route_header.route_ends_at"
              intlValues={{ time: dateFormatShortTime(selectedRoute.estimated_end_time) }}
            />
          </>
        )}
      </Grid>
      <div
        style={{
          position: `absolute`,
          bottom: 0,
          left: 0,
          width: `100%`,
          height: `4px`,
          backgroundColor: RoutalPalette.grey2,
        }}
      >
        <DriverProgress style={{ margin: 0 }} hasStops={Boolean(selectedRoute.stops.length > 0)}>
          {selectedRoute.stops.map((stop: Stop) => (
            <DriverProgressItem key={stop.id} status={stop.status} />
          ))}
        </DriverProgress>
      </div>
    </Grid>
  );
};
